module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "generic-no-results.e54f44b5.svg";